// extracted by mini-css-extract-plugin
export default {"form-backdrop":"SignupForm_form-backdrop__AF1tb","form-container":"SignupForm_form-container__Dyvbz","invalid":"SignupForm_invalid__131Lg"};